import { Theme } from '@mui/material';
/**
 * CcfCustomerCard - used to display quick replies component
 * @param props -?-customerCardDetailsStyles
 * @example <customerCardDetailsStyles />
 */
const dispositionAccordionStyles = (theme: Theme) => {
  const accStyles = {
    customerCardContainer: {
      width: '100%',
      [theme.breakpoints.down('xl')]: {
        marginLeft: '0px',
        overflow: 'auto',
      },
      [theme.breakpoints.up('xl')]: {
        marginLeft: '0px',
        height: '100%',
        overflow: 'auto',
      },
      height: '100%',
      overflow: 'auto',
      '&::-webkit-scrollbar': {
        width: '0.4em',
      },
    },

    accordionContainer: {
      display: 'block',
      width: 'inherit',
      minHeight: '59px',
      borderTopLeftRadius: '0px',
      borderTopRightRadius: '0px',
      letterSpacing: '0px',
      margin: '0 0 !important',
      boxShadow: 'none !important',
      background: '0% 0% no-repeat padding-box #eaf1f7',
      opacity: '0.75',
    },
    accordionHeader: {
      flexDirection: 'row-reverse',
      paddingLeft: '10px',
    },
    accordionHeaderExpand: {
      flexDirection: 'row-reverse',
      paddingLeft: '10px',
      borderTop: `solid ${theme.palette.background.default} 1px`,
      boxShadow: '0px -1px 1px #e7eaec',
    },
    accordionHeaderActivityExpand: {
      flexDirection: 'row-reverse',
      paddingLeft: '10px',
      borderTop: `solid ${theme.palette.background.default} 1px`,
      boxShadow: `-1px 1px 1px #fdeeef`,
    },
    contactCardDetailsContainer: {
      maxHeight: '150px',
      overflowY: 'auto',
      paddingLeft: '20px',
    },
    expandedIcon: {
      transform: 'rotate(180deg)',
      height: '18px',
      width: '20px',
      color: `#5B7C8C`,
    },
    contactCardTitle: {
      font: `normal normal 600 14px/${theme.typography.h5.fontSize} ${theme.typography.fontFamily}`,
      letterSpacing: '0px',
      color: theme.palette.text.primary,
      opacity: 1,
    },
    customerNoteParent: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
    },
    hideAccordion: {
      display: 'none',
    },
    mergeIcon: {
      position: 'absolute',
      right: theme.spacing(1),
    },
    ccAlert: {
      position: 'sticky',
      bottom: 0,
      width: '100%',
    },
    notesAccordionTitle: {
      fontWeight: '600',
    },
    addressContainer: {
      paddingBottom: '14px',
      boxShadow: 'none !important',
      margin: '0px !important',
    },
    addressDetails: {
      // padding: '0px !important',
      display: 'flex',
      flexDirection: 'column',
      borderBottom: '1px solid #dae2e8',
    },
    accordionRootNotes: {
      paddingBottom: '15px',
      boxShadow: 'none !important',
      margin: '0px !important',
    },
    contacthistory: {
      paddingBottom: '15px',
      boxShadow: 'none !important',
      margin: '0px !important',
    },
    contactHistoryDetails: {
      padding: '0px 7px !important',
      marginTop: '5px !important',
      display: 'flex',
      flexDirection: 'column',
    },
    channelDetails: {
      width: '100%',
      padding: '0px !important',
    },
    customDropdown: {
      height: '35px',
      width: '280px !important',
      background: '0% 0% no-repeat padding-box #fff !important',
      border: '1px solid #dae2e8',
      borderRadius: '4px',
      opacity: '1',
      paddingLeft: '5px',
      marginLeft: '10px',
      paddingRight: '0px !important',
      marginTop: '5px',
      marginBottom: '5px',
      boxShadow: 'none',
      font: 'normal normal normal 14px/19px Open Sans',
      letterSpacing: '0px',
      color: '#333333',
      '&::invalid': {
        color: '#fc0000',
      },
    },
    captionForDropdown: {
      top: '205px',
      left: '603px',
      paddingLeft: '10px',
      width: '100%',
      height: '15px',
      font: 'normal normal bold 11px/15px Open Sans',
      letterSpacing: '0px',
      color: '#8c95a5',
      textTransform: 'uppercase',
      opacity: '1',
    },
  };
  return accStyles;
};
export default dispositionAccordionStyles;
